export default {
  en: {
    INPUT_EMAIL: 'Email Address',
    INPUT_EMAIL_ERROR: 'Invalid email',
    INPUT_EMAIL_ERROR_DESCRIPTION: 'Please enter a valid email address',
    INPUT_TWO_FACTOR_CODE: 'MFA Code',
    INPUT_TWO_FACTOR_TITLE: 'Multi-factor Authentication',
    INPUT_TWO_FACTOR_CODE_ERROR: 'Invalid code',
    INPUT_TWO_FACTOR_CODE_ERROR_DESCRIPTION: 'Please enter a valid multi-factor code',
    TWO_FACTOR_FORM_APP_INSTRUCTION: 'Open your authenticator app and enter the 6-digit code displayed.',
    TWO_FACTOR_FORM_APP_ADDITIONAL_INSTRUCTION: 'Having trouble? {link}',
    TWO_FACTOR_FORM_APP_ADDITIONAL_INSTRUCTION_LINK: 'Click here to learn more',
    INPUT_PASSWORD: 'Password',
    INPUT_PASSWORD_ERROR: 'Password Required',
    INPUT_PASSWORD_ERROR_DESCRIPTION: 'Please enter your password',
    INPUT_REMEMBER_DEVICE: 'Remember this device – Do not use this option on shared or public devices.',
    FORGOT_PASS_LINK: 'Forgot Password?',
    LOGIN_BUTTON: 'Login',
    VALIDATE_TWO_FACTOR_BUTTON: 'Verify',
    PASS_RECOVERY_BUTTON: 'Send me a recovery link',
    PASS_RECOVERY_SUCCESS_TITLE: 'Password reset request sent.',
    PASS_RECOVERY_SUCCESS_FIRST_LINE: 'A password reset message was sent to your email address. Please click the link in the email to reset your password.',
    PASS_RECOVERY_SUCCESS_SECOND_LINE: ' If you do not receive the password reset message within a few minutes, please check your spam folder or other filtering tools.',
    BACK_LOGIN_LINK: 'Back To Login',
    BACK_RESET_PASSWORD_LINK: 'Back To Password Reset',
    BACK_DASHBOARD_LINK: 'Back To Dashboard',
    PASS_RESET_SUCCESS_TITLE: 'Password reset successful.',
    PASS_RESET_SUCCESS_FIRST_LINE: 'Your password has been changed, you can now use it to log into Ringba',
    INPUT_NEW_PASSWORD: 'New Password',
    INPUT_NEW_PASSWORD_ERROR: 'Invalid Password',
    INPUT_CONFIRM_PASSWORD: 'Confirm Password',
    RESET_PASSWORD_BUTTON: 'Reset Password',
    JOIN_INVITE_FAILURE: 'Invalid Invite',
    JOIN_INVITE_SUCCESS: 'Thank you for accepting the invitation.',
    JOIN_INVITE_SUCCESS_SUBHEADER: 'You can now log in using your account',
    JOIN_INVITE_SUCCESS_LOGGED_SUBHEADER: 'Click below to continue using Ringba.',
    JOIN_ORP_INVITE_SUCCESS: 'Thank you for confirming your {applicantType} registration',
    INPUT_FIRST_NAME: 'First Name',
    INPUT_FIRST_NAME_ERROR: 'First Name missing',
    INPUT_FIRST_NAME_ERROR_DESCRIPTION: 'Please enter your first name',
    INPUT_LAST_NAME: 'Last Name',
    INPUT_LAST_NAME_ERROR: 'Last Name missing',
    INPUT_LAST_NAME_ERROR_DESCRIPTION: 'Please enter your last name',
    JOIN_INVITE_BUTTON: 'Join Invite',
    JOIN_PRP_INVITE_BUTTON: 'Register',
    TERMS_EROR: 'Terms of Service not Accepted',
    JOIN_INVITE_TERMS_PREFIX: 'I agree to the',
    JOIN_INVITE_TERMS_LINK: 'Terms of Service',
    JOIN_INVITE_TERMS_AND: 'and',
    JOIN_INVITE_PRIVACY_POLICY: 'Privacy Policy',
    INPUT_BUSINESS_NAME: 'Business Name',
    INPUT_BUSINESS_NAME_ERROR: 'Business Name missing',
    INPUT_BUSINESS_NAME_ERROR_DESCRIPTION: 'Please, fill out this field',
    INPUT_PHONE_NUMBER: 'Phone Number (Optional)',
    INPUT_PHONE_NUMBER_ERROR: 'Phone Number missing',
    INPUT_PHONE_NUMBER_ERROR_DESCRIPTION: 'Please, fill out this field',
    PRP_TERMS_PREFIX: 'I agree to the',
    PRP_TERMS_LINK: 'Terms and Conditions',
    PRP_REGISTER_BUTTON: 'Register as a Publisher',
    PRP_TERMS_MODAL_CLOSE: 'Close',
    PRP_SUB_HEADER: 'Please share some details about you and your business to register as a publisher',
    PRP_THANK_YOU_HEADER: 'Thank you',
    PRP_THANK_YOU_LINE1: 'Your publisher registration request has been submitted.',
    JOIN_ORP_INVITE_SUB_HEADER_1: 'You are almost done setting up as a {applicantType} {applicantName} at {accountName}',
    JOIN_PRP_INVITE_SUB_HEADER_2: 'Please specify your new password',
    ORP_SUB_HEADER: 'Please share some details about you and your business to register as a {applicantType}',
    ORP_REGISTER_BUTTON: 'Register as a {applicantType}',
    ORP_TERMS_MODAL_HEADER: 'Terms And Conditions',
    ORP_THANK_YOU_LINE2: 'You will receive an email with instruction on how to confirm your identity and, if necessary, set a password for your new Ringba user login.',
    ORP_THANK_YOU_LINE1: 'Your {applicantType} registration request has been submitted.',
    ORP_CLOSED_LINE1: '{applicantType} Registration is closed at the moment, please reach out to the person who have provided you with the link.',
    ORP_CLOSED_LINE2: 'Visit {link} to learn more about Ringba',
    ORP_CLOSED_LINE2_LINK: 'ringba.com',
    ORP_FOOTER_CONTACT_EMAIL: 'Please forward any questions or concerns regarding {applicantType} registration to {contactEmail}',
  }
};